// Reset password form - calls Rails backend directly

document.addEventListener('turbo:load', () => {
  const resetForm = document.getElementById('reset-password-form');
  
  if (resetForm) {
    const token = resetForm.dataset.token;
    // Check if first path segment is 'en', otherwise default to Greek
    const pathSegment = window.location.pathname.split('/')[1];
    const locale = pathSegment === 'en' ? 'en' : '';
    const basePath = locale ? `/${locale}` : '';
    
    const errorDiv = document.getElementById('error-message');
    const successDiv = document.getElementById('success-message');

    resetForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideMessages();

      const password = document.getElementById('new-password').value;
      const passwordConfirmation = document.getElementById('confirm-password').value;

      if (password !== passwordConfirmation) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.passwords_dont_match'] || 'Passwords do not match');
        return;
      }

      if (password.length < 8) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.weak_password'] || 'Password must be at least 8 characters');
        return;
      }

      try {
        const response = await fetch(`${basePath}/reset-password/${token}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ password, password_confirmation: passwordConfirmation })
        });

        const data = await response.json();
        
        if (data.success) {
          showSuccess(window.I18n?.['auth.password_reset_success'] || 'Password reset successfully! Redirecting to login...');
          setTimeout(() => {
            window.location.href = `${basePath}/login`;
          }, 2000);
        } else {
          showLoading(false);
          showError(data.error);
        }

      } catch (error) {
        console.error('Reset password error:', error);
        showLoading(false);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Failed to reset password. Please try again.');
      }
    });

    function showError(message) {
      if (errorDiv) {
        errorDiv.textContent = message;
        errorDiv.classList.remove('hidden');
      }
    }

    function showSuccess(message) {
      if (successDiv) {
        successDiv.textContent = message;
        successDiv.classList.remove('hidden');
      }
    }

    function hideMessages() {
      errorDiv?.classList.add('hidden');
      successDiv?.classList.add('hidden');
    }

    function showLoading(loading) {
      const btnText = document.getElementById('reset-btn-text');
      const btnLoading = document.getElementById('reset-btn-loading');
      
      if (loading) {
        btnText?.classList.add('hidden');
        btnLoading?.classList.remove('hidden');
      } else {
        btnText?.classList.remove('hidden');
        btnLoading?.classList.add('hidden');
      }
    }
  }
});
